import Vue from "vue";
import VueRouter from "vue-router";
import ProductDetail from "../components/ProductDetail.vue";
import ImageList from "../components/ImageList.vue";
import ThumbnailList from "../components/ThumbnailList.vue";

const make_router = function(widgetProps: object) {
  return new VueRouter({
    linkActiveClass: "is-active",
    mode: "abstract",
    routes: [
      {
        path: "/product_detail",
        component: ProductDetail,
        name: "shop_fe-product_detail",
        props: widgetProps,
      },

      {
        path: "/images",
        component: ImageList,
        name: "productdetail-imagelist",
        props: widgetProps,
      },
      {
        path: "/thumbnails",
        component: ThumbnailList,
        name: "productdetail-thumbnails",
        props: widgetProps,
      },
    ],
  });
};

export default make_router;
